<!--
 * @Description: 全局常规通用数据表格 带搜索栏、分页、操作
 * @Author: xiawenlong
 * @Date: 2020-12-21 19:52:13
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-24 18:58:14
-->
<template>
  <div class="table-list">
    <table-search-bar
      v-if="searchForm.length"
      ref="tableSearchBar"
      :search-form="searchForm"
      :search-form-more="searchFormMore"
      :search-form-more-text-show="searchFormMoreTextShow"
      :btns="btns"
      @search="onSearch"
    ></table-search-bar>
    <div v-if="title" class="top-bar">
      <div class="titleBar">
        <span class="title">{{ title }}</span>
      </div>
      <div class="float btns">
        <template v-for="(btn, key) in btns">
          <el-button
            v-if="!btn.isShow || (btn.isShow && !btn.isShow)"
            :key="key"
            :type="btn.type || 'primary'"
            :icon="btn.icon"
            :width="btn.width"
            :loading="btn.loading"
            @click.native.prevent="btn.method"
          >
            {{ btn.label }}
          </el-button>
        </template>
      </div>
    </div>
    <el-tabs v-if="tabs.length" v-model="activeTab" class="tabs" @tab-click="tabChange">
      <el-tab-pane v-for="(item, index) in tabs" :key="index" :label="item.label" :name="item.name">
      </el-tab-pane>
    </el-tabs>
    <div v-if="singleOptions && singleOptions.title" class="single-top">
      <span class="single-top-text">{{ singleOptions.title }}</span>
      <el-radio-group
        v-for="(item, index) in singleOptions.titleArray"
        :key="index"
        v-model="radio"
        @change="singleOptionsAction(index)"
      >
        <el-radio class="single-top-text" :label="index">{{ item }}</el-radio>
        <!-- <el-radio class="single-top-text" :label="2">片段</el-radio> -->
      </el-radio-group>
    </div>
    <div
      class="table-main"
      :style="singleOptions && singleOptions.title ? 'height: calc(100% - 93px)' : ''"
    >
      <el-table
        ref="tableList"
        v-loading="loading"
        :row-key="options && options.rowKey"
        :tree-props="treeProps"
        stripe
        :data="data"
        tooltip-effect="dark"
        style="width: 100%"
        :height="tableHeight"
        :max-height="options && options.maxHeight"
        v-bind="options"
        :highlight-current-row="options && options.singleCurrent"
        :span-method="spanMethod"
        :row-class-name="rowClassName"
        @selection-change="handleSelectionChange"
        @current-change="handleSingleChange"
        @cell-click="handleCellClick"
        @sort-change="handleSortChange"
      >
        <!-- 复选框 -->
        <el-table-column
          v-if="options && options.selection && (!options.isShow || options.isShow())"
          :reserve-selection="options.reserveSelection"
          :selectable="options.selectable"
          type="selection"
          style="width: 55px;"
        />
        <!-- 用于拖拽的列 -->
        <el-table-column
          v-if="rowSort"
          type="index"
          label="排序"
          align="center"
          class-name="handle"
        >
          <i class="el-icon-rank" style="font-size: 14px;" />
        </el-table-column>
        <!-- 索引 -->
        <el-table-column
          v-if="options && options.index"
          width="60"
          align="center"
          type="index"
          :label="options && options.labelIndex"
        />
        <el-table-column
          v-for="(col, index) in columns"
          :key="col.prop"
          :prop="col.prop"
          :show-overflow-tooltip="col.tooltip"
          :label="col.label"
          :align="col.align"
          :width="col.width"
          :min-width="col.minWidth"
          :render-header="col.renderHeader ? col.renderHeader : null"
          :sortable="col.sortable"
          :fixed="col.fixed"
        >
          <template v-if="col.sortdata" slot="header">
            <div class="sortHeader" @click="sortSearch(col.sortdata)">
              {{ col.label }}
              <el-tooltip v-if="col.tip" effect="dark" :content="col.tip" placement="top">
                <i class="el-icon-info" style="color:#588DD6"></i>
              </el-tooltip>
              <span class="caret-wrapper">
                <i
                  :class="[
                    'sort-caret ascending',
                    { active: ruleType == 1 && ruleName == col.sortdata },
                  ]"
                ></i>
                <i
                  :class="[
                    'sort-caret descending',
                    { active: ruleType == 2 && ruleName == col.sortdata },
                  ]"
                ></i>
              </span>
            </div>
          </template>
          <template v-else-if="col.tip">
            <div slot="header">
              {{ col.label }}
              <el-tooltip v-if="col.tip" effect="dark" :content="col.tip" placement="top">
                <i class="el-icon-info" style="color:#588DD6"></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            <template>
              <template v-if="!col.render">
                <template v-if="col.formatter">
                  <span
                    @click="col.click && col.click(scope.row, scope.$index)"
                    v-text="col.formatter(scope.row, col, scope.$index)"
                  ></span>
                </template>
                <template v-else>
                  <el-tooltip
                    v-if="col.twoLines"
                    class="twoLinesRow"
                    popper-class="twoLinesRowTooltip"
                    effect="dark"
                    :content="scope.row[col.prop]"
                    placement="top"
                  >
                    <div>
                      {{ scope.row[col.prop] }}
                    </div>
                  </el-tooltip>
                  <span
                    v-else
                    :style="col.click ? 'color: #409EFF; cursor: pointer;' : null"
                    @click="col.click && col.click(scope.row, scope.$index)"
                  >
                    {{ scope.row[col.prop] }}
                  </span>
                </template>
              </template>
              <template v-else>
                <render :column="col" :row="scope.row" :render="col.render" :index="index"></render>
              </template>
            </template>
          </template>
        </el-table-column>
        <!-- 操作按钮 -->
        <el-table-column
          v-if="operates && operates.length > 0"
          :width="options && options.operatesWidth"
          label="操作"
          fixed="right"
          align="left"
        >
          <template slot-scope="scope">
            <div class="operate-group">
              <template v-for="(btn, key) in operates">
                <span
                  v-if="
                    btn.label &&
                      (!btn.isShow || (btn.isShow && btn.isShow(scope.row, scope.$index)))
                  "
                  :key="key"
                  @click="btn.method(scope.row, scope.$index)"
                  >{{ btn.label }}</span
                >
                <span
                  v-if="
                    (btn.icon || btn.img) &&
                      (!btn.isShow || (btn.isShow && btn.isShow(scope.row, scope.$index)))
                  "
                  :key="key"
                >
                  <i
                    v-show="btn.icon"
                    :class="btn.icon"
                    @click="btn.method(scope.row, scope.$index)"
                  ></i>
                  <img
                    v-show="btn.img"
                    :src="btn.img"
                    :width="btn.width || '16'"
                    :height="btn.height || 'auto'"
                    @click="btn.method(scope.row, scope.$index)"
                  />
                </span>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="footerBtns.length || pager || footerTip" class="footer">
        <!-- <span v-if="options && options.selection" class="checkedBox">
          <el-checkbox
            v-model="checkAll"
            :indeterminate="isIndeterminate"
            @change="handleCheckAllChange"
            >选择全部</el-checkbox
          >
        </span> -->
        <div v-for="(btn, key) in footerBtns" :key="key" class="btns">
          <span v-if="!btn.isShow || (btn.isShow && !btn.isShow)">
            <el-button
              :type="btn.type || 'primary'"
              :icon="btn.icon"
              :loading="btn.loading"
              @click.native.prevent="btn.method"
            >
              {{ btn.label }}
            </el-button>
          </span>
        </div>
        <!-- <span v-for="(btn, key) in footerBtns" :key="key" class="btns">
          <el-button
            :type="btn.type || 'primary'"
            :icon="btn.icon"
            @click.native.prevent="btn.method"
          >
            {{ btn.label }}
          </el-button>
        </span> -->
        <div v-if="footerTip" class="footerTip">{{ footerTip }}</div>
        <el-pagination
          v-if="pager"
          background
          :current-page="pager.current"
          :page-sizes="(options && options.pageSize) || [20, 50, 100, 500]"
          :page-size="pager.size"
          layout="total, prev, pager, next, sizes, jumper"
          :total="pager.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
import TableSearchBar from './TableSearchBar'
export default {
  name: 'TableList',
  components: {
    TableSearchBar,
    render: {
      functional: true,
      props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
          type: Object,
          default: null,
        },
      },
      render: (h, opt) => {
        const params = {
          row: opt.props.row,
          index: opt.props.index,
        }
        if (opt.props.column) params.column = opt.props.column
        return opt.props.render(h, params)
      },
    },
  },
  props: {
    treeProps: {
      type: Object,
      default: () => {},
    },
    searchFormMoreTextShow: {
      type: Boolean,
      default: false,
    },
    searchForm: {
      type: Array,
      default: () => [],
    },
    searchFormMore: {
      type: Array,
      default: () => [],
    },
    btns: {
      type: Array,
      default: () => [],
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    defaultActiveTab: {
      type: [Number, String],
      default: '',
    },
    footerBtns: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    operates: {
      type: Array,
      default: () => [],
    },
    pager: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
    singleOptions: {
      type: Object,
      default: () => {},
    },
    spantext: {
      type: String,
      default: '',
    },
    reserveSelection: {
      type: Boolean,
      default: false,
    },
    rowSort: {
      type: Boolean,
      default: false,
    },
    backBtn: {
      type: Object,
      default: () => {},
    },
    footerTip: {
      type: String,
      default: '',
    },
    spanMethod: {
      type: Function,
      default: () => {},
    },
    rowClassName: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      params: {},
      ruleName: -1,
      ruleType: 0,
      tableHeight: null,
      radio: 0,
      activeTab: this.defaultActiveTab,
    }
  },
  watch: {
    data() {
      this.checkAll = false
      // console.log(11122233)
      setTimeout(() => {
        this.doLayout()
      }, 500)
    },
    defaultActiveTab(val) {
      this.activeTab = val
    },
  },
  mounted() {
    if (this.rowSort) this.sortable()
    this.$nextTick(() => {
      this.doLayout()
    })
    window.onresize = () => {
      this.doLayout()
    }
  },
  methods: {
    singleOptionsAction(index) {
      this.$emit('singleOptionsAction', index)
    },
    // 分页
    handleSizeChange(size) {
      this.$emit('size-change', size)
    },
    handleCurrentChange(current) {
      this.$emit('current-change', current)
    },
    onSearch(params) {
      this.params = { ...this.params, ...params }
      this.$emit('search', this.params)
    },
    handleSelectionChange(params) {
      let checkedCount = params.length
      this.checkAll = checkedCount === this.data.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.data.length
      this.$emit('selectionChange', params)
    },
    tabChange(e) {
      this.$emit('handleTabChange', e.name)
    },
    handleSingleChange(params) {
      this.$emit('singleSelectChange', params)
    },
    handleCheckAllChange() {
      this.$refs.tableList.toggleAllSelection()
      this.isIndeterminate = false
    },
    handleSortChange(params) {
      this.$emit('sort-change', params)
    },
    // 表头排序（接口
    sortSearch(val) {
      if (this.ruleName !== val) {
        this.ruleName = val
        if (this.ruleType > 0) {
          this.ruleType = 0
        }
      }
      if (this.ruleType == 2) {
        this.ruleType = 0
        this.params = {
          ...this.params,
          ...(this.$refs.tableSearchBar ? this.$refs.tableSearchBar.searchData : {}),
          ruleName: undefined,
          ruleType: undefined,
        }
        this.$emit('search', this.params)
      } else {
        this.ruleType = this.ruleType + 1
        this.params = {
          ...this.params,
          ...(this.$refs.tableSearchBar ? this.$refs.tableSearchBar.searchData : {}),
          ruleName: this.ruleName,
          ruleType: this.ruleType,
        }
        this.$emit('search', this.params)
      }
    },
    handleCellClick(row, column) {
      if (column.className == 'el-table-column--selection') {
        if (this.options.selectable && !this.options.selectable(row)) return
        this.$refs.tableList.toggleRowSelection(row)
      }
    },
    sortable() {
      const table = this.$refs.tableList.$el.querySelectorAll(
        '.el-table__body-wrapper > table > tbody',
      )[0]
      Sortable.create(table, {
        handle: '.handle',
        // 拖拽完毕后触发
        onEnd(e) {
          const { newIndex, oldIndex } = e
          if (newIndex === oldIndex) return
          console.log(newIndex, oldIndex)
          this.$emit('tableRowSort', e)
        },
      })
    },
    resetWrapperHeight() {
      this.$nextTick(() => {
        const height = document.querySelector('.el-table__header').offsetHeight
        console.log(height)
        document.querySelector('.el-table__body-wrapper').style.height = `calc(100% - ${height +
          50}px) !important`
        if (document.querySelector('.el-table__fixed-body-wrapper')) {
          document.querySelector(
            '.el-table__fixed-body-wrapper',
          ).style.height = `calc(100% - ${height}px) !important`
        }
        setTimeout(() => {
          if (document.querySelector('.el-table__fixed')) {
            document.querySelector('.el-table__fixed').style.height = `calc(${
              document.querySelector('.el-table__body-wrapper').clientHeight
            }px + ${height}px)`
          }
        }, 100)
      })
      this.$refs.tableList.doLayout()
    },
    doLayout() {
      this.$nextTick(() => {
        let TopBarHeight = 0
        let SearchBarHeight = 0
        let FooterHeight = 0
        if (document.querySelector('.top-bar')) TopBarHeight = 60
        if (document.querySelector('.table-search-bar'))
          SearchBarHeight = document.querySelector('.table-search-bar').offsetHeight
        if (document.querySelector('.footer')) FooterHeight = 60
        if (document.querySelector('.table-main')) {
          document.querySelector('.table-main').style.height = `calc(100% - ${TopBarHeight +
            SearchBarHeight}px)`
          this.tableHeight = document.querySelector('.table-main').offsetHeight - FooterHeight
        }
        if (this.$refs.tableList) this.$refs.tableList.doLayout()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.table-list {
  width: 100%;
  height: 100%;
  .twoLinesRow {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }
  .top-bar {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .titleBar {
      display: flex;
      align-items: center;
    }
    .el-button {
      height: 36px;
      line-height: 34px;
      box-sizing: border-box;
      min-width: 80px;
      width: auto;
      padding: 0 10px;
      margin: 0 10px 0 0;
      &:last-of-type {
        margin-right: 0;
      }
    }
    /deep/ .backBtn {
      box-sizing: border-box;
      width: 122px;
      height: 27px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      margin-left: 18px !important;
      font-size: 14px;
      color: #606266;
      > span {
        width: 122px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        width: 15px;
        height: 14px;
        margin-right: 3px;
      }
    }
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #4d4e5d;
    }
    .spantext {
      display: block;
      margin-top: 5px;
      font-size: 14px;
      font-weight: 400;
      color: #4d4e5d;
    }
    .btns {
      margin-left: auto;
      > span {
        margin-right: 20px;
        &:last-of-type {
          margin: 0;
        }
        .el-button {
          width: 120px;
        }
      }
    }
    .el-button {
      margin: 0;
      margin-right: 20px;
      &:last-of-type {
        margin: 0;
      }
    }
  }

  .single-top {
    height: 40px;
    padding: 0px 10px;
    background-color: #ffffff;
    margin-bottom: 1px;
    display: flex;
    align-items: center;
  }
  .single-top-text {
    color: #6f7986;
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    margin-right: 10px;
  }

  .operate-group {
    display: flex;
    align-items: center;
    img {
      cursor: pointer;
    }
    span {
      cursor: pointer;
      color: #3671bf;
      font-size: 14px;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .sortHeader {
    height: 31px;
    cursor: pointer;
    i {
      &.ascending.active {
        border-bottom-color: #588dd6;
      }
      &.descending.active {
        border-top-color: #588dd6;
      }
    }
  }
  .table-main {
    position: relative;
    height: calc(100% - 116px);
    background-color: #fff;
    /deep/.el-table {
      height: 100%;
      .el-table__fixed,
      .el-table__fixed-right {
        height: auto !important;
        bottom: 8px !important; //具体值是多少根据你横向滚动条的高度进行设置
      }
      //去掉固定列下方的横线
      .el-table__fixed::before,
      .el-table__fixed-right::before {
        display: none;
      }
      .el-table__header-wrapper,
      .el-table__fixed-header-wrapper {
        th.el-table__cell {
          padding: 8px 0;
        }
      }
      .el-table-column--selection .cell {
        padding-left: 10px;
        padding-right: 10px;
      }
      .handle {
        .el-icon-rank {
          cursor: move;
          color: rgb(89, 142, 214);
          font-size: 16px !important;
        }
      }
    }
    .footer {
      z-index: 99;
      position: absolute;
      bottom: 0;
      left: 0;
      width: calc(100% - 20px);
      height: 50px;
      background: #ffffff;
      box-shadow: 0px -2px 6px 1px #e6e6e6;
      border-radius: 0px 0px 0px 0px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      padding-bottom: 10px;
      .checkedBox {
        font-size: 14px;
        font-weight: 400;
        color: #6f7986;
        margin-right: 10px;
        /deep/ .el-checkbox__input {
          margin-right: 10px;
        }
      }
      .btns {
        margin-right: 10px;
        &:last-of-type {
          margin: 0;
        }
        .el-button {
          width: 100px;
          height: 36px;
        }
      }
      .el-pagination {
        margin-left: auto;
      }
    }
    .footerTip {
      font-size: 14px;
      font-weight: 400;
      color: #ff0000;
      margin-left: 20px;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 60% !important;
}
</style>
